package com.example.event_management_system.di

import com.example.event_management_system.data.repository.AuthRepository
import com.example.event_management_system.data.repository.EmailRepository
import com.example.event_management_system.data.repository.EmailWorkspaceRepository
import com.example.event_management_system.data.repository.EventRepository
import com.example.event_management_system.data.repository.IAuthRepository
import com.example.event_management_system.data.repository.IEmailRepository
import com.example.event_management_system.data.repository.IEmailWorkspaceRepository
import com.example.event_management_system.data.repository.IEventRepository
import com.example.event_management_system.data.repository.ILocationRepository
import com.example.event_management_system.data.repository.ISectionRepository
import com.example.event_management_system.data.repository.IUserRepository
import com.example.event_management_system.data.repository.LocationRepository
import com.example.event_management_system.data.repository.SectionRepository
import com.example.event_management_system.data.repository.UserRepository
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.auth
import dev.gitlive.firebase.firestore.firestore
import dev.gitlive.firebase.functions.functions
import dev.gitlive.firebase.storage.storage
import com.example.event_management_system.ui.screens.admin.AdminDashboardScreenModel
import com.example.event_management_system.ui.screens.calendar.CalendarScreenModel
import com.example.event_management_system.ui.screens.location.LocationPickerScreenModel
import com.example.event_management_system.ui.screens.events.EventDetailScreenModel
import com.example.event_management_system.ui.screens.events.EventFormScreenModel
import com.example.event_management_system.ui.screens.events.EventListScreenModel
import com.example.event_management_system.ui.screens.login.LoginScreenModel
import com.example.event_management_system.ui.screens.settings.SettingsScreenModel
import org.koin.core.module.dsl.factoryOf
import org.koin.dsl.module

val appModule = module {
    // Firebase SDK instances
    single { Firebase.auth }
    single { Firebase.firestore }
    single { Firebase.storage }
    single { Firebase.functions }

    // Repositories - bound to interfaces so ScreenModels can inject by interface type
    single<IAuthRepository> { AuthRepository(get()) }
    single<IEventRepository> { EventRepository(get()) }
    single<IUserRepository> { UserRepository(get()) }
    single<ILocationRepository> { LocationRepository(get()) }
    single<ISectionRepository> { SectionRepository(get()) }
    single<IEmailRepository> { EmailRepository(get()) }
    single<IEmailWorkspaceRepository> { EmailWorkspaceRepository(get()) }

    // Screen Models
    factoryOf(::LoginScreenModel)
    factoryOf(::CalendarScreenModel)
    factoryOf(::EventListScreenModel)
    factoryOf(::EventDetailScreenModel)
    factoryOf(::EventFormScreenModel)
    factoryOf(::SettingsScreenModel)
    factoryOf(::AdminDashboardScreenModel)
    factoryOf(::LocationPickerScreenModel)
}
